import { OnInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-share',
  templateUrl: './modal-share.component.html',
  styleUrls: ['./modal-share.component.scss'],
})
export class ModalShareComponent implements OnInit {
  @Input() bien: any;
  @Input() detailBien: any;
  @Input() colorIcon = "white"
  launchedRequest = false;
  showSendMail = false;

  formShareFriend: any = {
    lastname: '',
    email: '',
    email1: '',
    email2: '',
    email3: '',
    messsage: '',
  };
  descBlock: any;
  urlForNotFb?: string;
  share = {
    gfb: '',
    twLink: '',
    twitterText: '',
  };
  global: any;

  constructor(private modalService: NgbModal, private router: Router) {}

  ngOnInit() {
    // console.log(this.bien)
    this.onSendData(this.bien);
  }

  toogleSendByMail() {
    this.showSendMail = !this.showSendMail;
  }

  openVertically(content: any) {
    this.modalService.open(content, { size: 'xl' });
  }

  onSendDataBlock(blockDesc?: any) {
    // console.log('ss');
  }

  onSendData(data: any) {
    this.descBlock = data;
    this.share.gfb = encodeURIComponent(data.urlPartage);
    this.share.twLink = data.blUrl;
    this.share.twitterText = data.twText;
  }

  SendShareFriend(param?: any, id?: any) {}
  onSendShareFriend(bien?: any) {}
}
